import { ComparisonBarChart, DonutChart, PiePercentageChart, ComparisonLineChart, MetricListCard } from '../components';
import type { DashboardSlot } from '../types/dashboard.types';

export const renderDashboardSlot = (slot: DashboardSlot) => {
	switch (slot.type) {
		case 'comparisonBar':
			return <ComparisonBarChart {...slot.config} data={slot.data} />;
		case 'donut':
			return <DonutChart {...slot.config} data={slot.data} />;
		case 'pie':
			return <PiePercentageChart {...slot.config} data={slot.data} />;
		case 'comparisonLine':
			return <ComparisonLineChart {...slot.config} data={slot.data} />;
		case 'metricList':
			return <MetricListCard {...slot.config} data={slot.data} />;
		default:
			return null;
	}
};
